import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, TemplateResult, html } from 'lit';
import componentStyles from './tufts-tag.css.lit';
import headingStyle from '../tufts-heading/tufts-heading.css.lit';
import { SlotNGController } from '../../controllers/slot-ng-controller';

/**
 * The TuftsTag component
 * @element tufts-tag
 *
 * @slot heading
 * @slot description
 *
 * @attr background-color

 */
@customElement('tufts-tag')
export class TuftsTag extends OutlineElement {
  ngSlot = new SlotNGController(this);

  static styles: CSSResultGroup = [componentStyles, headingStyle];

  @property({ type: Boolean, attribute: 'alt-style', reflect: true })
  altStyle = false;

  render(): TemplateResult {
    return html`
      <section class="tag-container ${this.altStyle ? 'alt-style' : ''}">
        ${this.ngSlot.conditionalNGSlot('heading', true, 'special-heading')}
        ${this.ngSlot.conditionalNGSlot('description')}
      </section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-tag': TuftsTag;
  }
}
